 <div class="card">
          <div class="card-header">
            <h4 class="card-title">{{ 'MENU.DASHBOARD.add_employee' | translate }}</h4>
            <!-- <button class="btn btn-primary" (click)="addCoupon()">
              Add Employees
            </button> -->
          </div>
          <div class="card-body">
            <p class="card-text">  {{ 'MENU.DASHBOARD.add_employee_description' | translate }}</p>
          </div>
        </div>


<div class="card">
  <div class="card-body">
    <form (ngSubmit)="onSubmit()" enctype="multipart/form-data">
      <div class="row">
      
          <div class="col-6">
            <div class="form-group">
              <div class="file-upload-container">
                <input type="file" id="logoUpload" accept="image/*" (change)="onFileSelected($event)" #imageInput>
                <div class="file-upload-label">
                  <i class="fas fa-cloud-upload-alt file-upload-icon"></i>
                  <div class="file-upload-text">{{ 'MENU.DASHBOARD.click_to_upload_imageEmp' | translate }}</div>
                  <div class="file-upload-text"> {{ 'MENU.DASHBOARD.drag_drop_image' | translate }}</div>
                  <div class="form-hint">{{ 'MENU.DASHBOARD.recommended_size' | translate }}</div>
                </div>
              </div>
              <!-- Image validation message -->
              <!-- <div *ngIf="imageInput.touched && !formData.image" class="text-danger small mt-1">
                {{ 'VALIDATION.image_required' | translate }}
              </div> -->
              <!-- رسالة إذا مافيش صورة -->
              <div class="no-preview" *ngIf="!formData.image">
                <div class="form-hint"> {{ 'MENU.DASHBOARD.no_imageEmp_uploaded' | translate }}</div>
              </div>
            </div>
          </div> 
         <!-- معاينة الصورة -->
          <div class="col-6">
            <div class="image-preview-container" *ngIf="formData.image">
              <div class="image-preview-header">
                <h6>{{ 'MENU.DASHBOARD.image_preview' | translate }}</h6>
                <button type="button" class="btn-close" (click)="removeImage()" aria-label="Close"></button>
              </div>
              <div class="image-preview">
                <img [src]="formData.image" alt="Preview" class="preview-image">
              </div>
            </div>
          </div>

      </div>


   <div class="row">
        <!-- Name -->
        <div class="col-sm-4">
          <div class="mb-3">
            <label class="form-label required-field">{{ 'MENU.DASHBOARD.name' | translate }}</label>
            <input
              type="text"
              class="form-control"
              [class.is-invalid]="name.invalid && name.touched"
              placeholder="{{ 'MENU.DASHBOARD.name' | translate }}"
              [(ngModel)]="formData.name"
              name="name"
              #name="ngModel"
              required
              minlength="2"
              maxlength="50"
            />
            <div *ngIf="name.invalid && name.touched" class="text-danger small mt-1">
              <div *ngIf="name.errors?.['required']">{{ 'MENU.DASHBOARD.name_required' | translate }}</div>
              <div *ngIf="name.errors?.['minlength']">{{ 'MENU.DASHBOARD.name_min_length' | translate }}</div>
            </div>
          </div>
        </div>

        <!-- Email -->
        <div class="col-sm-4">
          <div class="mb-3">
            <label class="form-label required-field">{{ 'MENU.DASHBOARD.email' | translate }}</label>
            <input
              type="email"
              class="form-control"
              [class.is-invalid]="email.invalid && email.touched"
              placeholder="{{ 'MENU.DASHBOARD.email' | translate }}"
              [(ngModel)]="formData.email"
              name="email"
              #email="ngModel"
              required
              email
            />
            <div *ngIf="email.invalid && email.touched" class="text-danger small mt-1">
              <div *ngIf="email.errors?.['required']">{{ 'MENU.DASHBOARD.email_required' | translate }}</div>
              <div *ngIf="email.errors?.['email']">{{ 'MENU.DASHBOARD.email_invalid' | translate }}</div>
            </div>
          </div>
        </div>

        <!-- Phone -->
        <div class="col-sm-4">
          <div class="mb-3">
            <label class="form-label required-field">{{ 'MENU.DASHBOARD.phone' | translate }}</label>
            <input
              type="text"
              class="form-control"
              [class.is-invalid]="phone.invalid && phone.touched"
              placeholder="{{ 'MENU.DASHBOARD.phone' | translate }}"
              [(ngModel)]="formData.phone"
              name="phone"
              #phone="ngModel"
              required
              pattern="^(009665|9665|\\+9665|05|5)(5|0|3|6|4|9|1|8|7)([0-9]{7})$"
              maxlength="14"
            />
            <div *ngIf="phone.invalid && phone.touched" class="text-danger small mt-1">
              <div *ngIf="phone.errors?.['required']">{{ 'MENU.DASHBOARD.phone_required' | translate }}</div>
              <div *ngIf="phone.errors?.['pattern']">{{ 'MENU.DASHBOARD.saudi_phone_only' | translate }}</div>
            </div>
          </div>
        </div>

        <!-- ID number -->
        <div class="col-sm-6">
          <div class="mb-3">
            <label class="form-label required-field">{{ 'MENU.DASHBOARD.id_number' | translate }} </label>
            <input
              type="text"
              class="form-control"
              [class.is-invalid]="identity_number.invalid && identity_number.touched"
              placeholder="{{ 'MENU.DASHBOARD.id_number' | translate }}"
              [(ngModel)]="formData.identity_number"
              name="identity_number"
              #identity_number="ngModel"
              required
              pattern="^[0-9]{10}$"
              maxlength="10"
            />
            <div *ngIf="identity_number.invalid && identity_number.touched" class="text-danger small mt-1">
              <div *ngIf="identity_number.errors?.['required']">{{ 'MENU.DASHBOARD.id_number_required' | translate }}</div>
              <div *ngIf="identity_number.errors?.['pattern']">{{ 'MENU.DASHBOARD.id_number_format' | translate }}</div>
            </div>
          </div>
        </div>

        <!-- Nationality -->
        <div class="col-sm-6">
          <div class="mb-3">
            <label class="form-label required-field">{{ 'MENU.DASHBOARD.nationality' | translate }}</label>
   
             <select
                class="form-control"
                [class.is-invalid]="nationality_id.invalid && nationality_id.touched"
                [(ngModel)]="formData.nationality_id"
                name="nationality_id"
                #nationality_id="ngModel"
                  (change)="onNationalityChange()"
                required
              >
                <option value="" disabled selected>
                  {{ 'MENU.DASHBOARD.select_countries' | translate }}
                </option>
                <option *ngFor="let title of countries" [value]="title.id">
                               {{  title.name  }}

              
                </option>
              </select>
            <div *ngIf="nationality_id.invalid && nationality_id.touched" class="text-danger small mt-1">
              <div *ngIf="nationality.errors?.['required']">{{ 'MENU.DASHBOARD.nationality_required' | translate }}</div>
              <div *ngIf="nationality.errors?.['minlength']">{{ 'MENU.DASHBOARD.nationality_min_length' | translate }}</div>
            </div>
          </div>
        </div>





      </div>
      <div class="row">
        <!-- City -->
        <div class="col-sm-6">
          <div class="mb-3">
            <label class="form-label required-field">{{ 'MENU.DASHBOARD.city' | translate }}</label>
          
             <select
              class="form-control"
              [class.is-invalid]="city_id.invalid && city_id.touched"
              [(ngModel)]="formData.city_id"
              name="city_id"
              #city_id="ngModel"
              required
            >
              <option value="" disabled selected>{{ 'MENU.DASHBOARD.select_city' | translate }}</option>
              <option *ngFor="let item of cities" [value]="item.id">
                {{ item?.name }}
              </option>
            </select>
            <div *ngIf="city_id.invalid && city_id.touched" class="text-danger small mt-1">
              {{ 'MENU.DASHBOARD.select_city' | translate }}
            </div>
            <div *ngIf="city_id.invalid && city_id.touched" class="text-danger small mt-1">
              <div *ngIf="city.errors?.['required']">{{ 'MMENU.DASHBOARD.city_required' | translate }}</div>
              <div *ngIf="city.errors?.['minlength']">{{ 'MENU.DASHBOARD.city_min_length' | translate }}</div>
            </div>
          </div>
        </div>
        <div class="col-sm-6">
          <div class="mb-3">
            <label class="form-label required-field">
              {{ 'MENU.DASHBOARD.job_title' | translate }}
            </label>

            <select
              class="form-control"
              [class.is-invalid]="job_title_id.invalid && job_title_id.touched"
              [(ngModel)]="formData.job_title_id"
              name="job_title_id"
              #job_title_id="ngModel"
              required
            >
              <option value="" disabled selected>
                {{ 'MENU.DASHBOARD.select_job_title' | translate }}
              </option>
              <option *ngFor="let title of jobTitles" [value]="title.id">
                {{ title.name}}
            
              </option>
            </select>

            <!-- Validation Messages -->
            <div *ngIf="job_title_id.invalid && job_title_id.touched" class="text-danger small mt-1">
              <div *ngIf="job_title_id.errors?.['required']">
                {{ 'MENU.DASHBOARD.job_title_required' | translate }}
              </div>
            </div>
          </div>
        </div>
      </div>
 
  

      <!-- Submit -->
      <div class="row">
        <div class="col-sm-6">
          <button type="submit" class="btn " style="background-color: #cca44c !important; color:#fff">{{ 'MENU.DASHBOARD.add' | translate }}</button>
        </div>
      </div>
    </form>
  </div>
</div>
